import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {noop} from '@republic/foundation/lang/function'
import {keys} from '@republic/foundation/lang/object'
import Particle from '../Particle'
import {config} from '../utils/config'
import {omit} from '../utils/lang'
import {create} from '../utils/style-manager'
import {color, type as colorType} from '../utils/styles/color'
import {decoration, type as decorationType} from '../utils/styles/text-decoration'
import {size, type as sizeType} from '../utils/styles/font-size'
import {weight, type as weightType} from '../utils/styles/font-weight'
import {height, type as heightType} from '../utils/styles/line-height'
import {align, type as alignType} from '../utils/styles/text-align'
import {transform, type as transformType} from '../utils/styles/text-transform'

const
    types = {
        className: PropTypes.string,
        tag: (
            PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.node,
                PropTypes.func
            ])),
        align: alignType,
        color: colorType,
        decoration: decorationType,
        leading: heightType,
        size: sizeType,
        transform: transformType,
        weight: weightType
    },

    Type = (
        class Type extends Component {
            static propTypes = types

            destroy = noop

            addStyle = () => {
                const
                    {destroy, style} = (
                        create(
                            'bits-type',
                            this.props,
                            {
                                ...weight(this.props.weight),
                                ...align(this.props.align),
                                ...color(this.props.color),
                                ...decoration(this.props.decoration),
                                ...height(this.props.leading),
                                ...size(this.props.size),
                                ...transform(this.props.transform)
                            }))

                this.destroy()
                this.destroy = destroy
                return style
            }

            componentWillUnmount() {
                this.destroy()
            }

            render() {
                return (
                    <Particle
                        tag={this.props.tag || config('Type').tag}
                        {...omit(this.props, keys(types))}
                        {...this.addStyle()} />
                )
            }
        })

export default Type
